
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"126","height":"246"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#0BDBF6","d":"M38.758 82L49 139H37.578L27 105.6l4.426-6.714 4.104-8.397zM73.742 139.189l7.342-61.482s3.841-35.12 16.453-23.828c12.61 11.292 4.282 33.72 4.282 33.72l-19.035 51.59h-9.042"}}),_c('path',{attrs:{"fill":"#FAB4CD","d":"M2.967 158.529l3.464 28.586 116.41 3.693-2.238-30.051z"}}),_c('path',{attrs:{"stroke":"#000","d":"M17.914 139.189L8.55 245.453h109.114L108.3 139.189zM0 139.189h125.807M26.871 152.625l-5.293 76.949M105.043 218.175l1.628 17.507M69.75 139.189s-1.628-56.934 6.515-77.501c8.143-20.567 19.01-34.682 28.778-18.938 9.767 15.744 11.396 25.515 4.88 42.345-6.514 16.83-23.343 54.094-23.343 54.094m11.943-88.771s-17.167 3.807-23.344 53.135M75.18 36.015l9.513-34.912M58.87 45.673L53.962 8.646M44.713 48.277L24.225 26.828M57.625 138.999s-5.473-65.928-9.993-71.163c-4.522-5.235-30.695-6.662-30.695-6.662S-.168 92.254 4.22 103.364c4.389 11.11 14.153 14.644 23.904 2.526 9.752-12.118 14.749-33.057 14.749-33.057M30.146 101.434l11.236 37.755"}})])])
          )
        }
      }
    